/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ letter: NonNullable<unknown>, name: NonNullable<unknown> }} Profile_Editors_Workout_LineInputs */

const en_us2_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout ${i?.letter} · ${i?.name}`)
};

const pt_br2_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.letter} · ${i?.name}`)
};

const es_419_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrenamiento ${i?.letter} · ${i?.name}`)
};

const pt_pt2_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.letter} · ${i?.name}`)
};

const fr_fr2_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance ${i?.letter} · ${i?.name}`)
};

const de_de2_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training ${i?.letter} · ${i?.name}`)
};

const it_it2_profile_editors_workout_line = /** @type {(inputs: Profile_Editors_Workout_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allenamento ${i?.letter} · ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Workout {letter} · {name}" |
*
* @param {Profile_Editors_Workout_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_workout_line = /** @type {((inputs: Profile_Editors_Workout_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Workout_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_workout_line(inputs)
	if (locale === "es-419") return es_419_profile_editors_workout_line(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_workout_line(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_workout_line(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_workout_line(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_workout_line(inputs)
	return en_us2_profile_editors_workout_line(inputs)
});
export { profile_editors_workout_line as "profile-editors.workout_line" }